(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function readZoomConfig(host) {
    const gallery = host.closest('media-gallery');
    if (!gallery) {
      return { lensSize: 112, zoomRatio: 2.35 };
    }
    const styles = getComputedStyle(gallery);
    const lensSize = parseFloat(styles.getPropertyValue('--renewbox-zoom-lens-size')) || 112;
    const zoomRatio = parseFloat(styles.getPropertyValue('--renewbox-zoom-ratio')) || 2.35;
    return { lensSize, zoomRatio };
  }

  function getZoomImageUrl(img) {
    const fromData = img.getAttribute('data-zoom-src');
    if (fromData) return fromData;

    const srcset = img.getAttribute('srcset');
    if (!srcset) return img.currentSrc || img.src;

    let bestUrl = img.currentSrc || img.src;
    let bestWidth = 0;

    srcset.split(',').forEach((part) => {
      const pieces = part.trim().split(/\s+/);
      const url = pieces[0];
      const width = parseInt(pieces[1], 10);
      if (width > bestWidth) {
        bestWidth = width;
        bestUrl = url;
      }
    });

    return bestUrl;
  }

  function getDisplayedImageMetrics(img, mountRect) {
    const nw = img.naturalWidth;
    const nh = img.naturalHeight;
    const cw = mountRect.width;
    const ch = mountRect.height;

    if (!nw || !nh || !cw || !ch) {
      return { width: cw, height: ch, offsetX: 0, offsetY: 0 };
    }

    const imageRatio = nw / nh;
    const containerRatio = cw / ch;
    let width;
    let height;
    let offsetX;
    let offsetY;

    if (imageRatio > containerRatio) {
      width = cw;
      height = cw / imageRatio;
      offsetX = 0;
      offsetY = (ch - height) / 2;
    } else {
      height = ch;
      width = ch * imageRatio;
      offsetX = (cw - width) / 2;
      offsetY = 0;
    }

    return { width, height, offsetX, offsetY };
  }

  function isActiveSlide(host) {
    const item = host.closest('.product__media-item');
    return !item || item.classList.contains('is-active');
  }

  function bindZoomHost(host) {
    if (host.dataset.renewboxZoomBound === 'true') return;

    const image = host.querySelector('img.renewbox-image-zoom');
    if (!image) return;

    const mount = host.closest('.product-media-container') || host;
    host.dataset.renewboxZoomBound = 'true';

    let lens = null;
    let lensImg = null;
    let zoomUrl = null;

    const removeLens = () => {
      if (lens) lens.remove();
      lens = null;
      lensImg = null;
    };

    const updateLensImage = (event) => {
      if (!DESKTOP_MQ.matches || !isActiveSlide(host) || !lens || !lensImg) return;

      const mountRect = mount.getBoundingClientRect();
      const metrics = getDisplayedImageMetrics(image, mountRect);
      const relX = event.clientX - mountRect.left - metrics.offsetX;
      const relY = event.clientY - mountRect.top - metrics.offsetY;

      const inside =
        relX >= 0 && relY >= 0 && relX <= metrics.width && relY <= metrics.height;

      if (!inside) {
        lens.style.visibility = 'hidden';
        return;
      }

      lens.style.visibility = 'visible';

      const x = event.clientX - mountRect.left;
      const y = event.clientY - mountRect.top;
      lens.style.left = `${x}px`;
      lens.style.top = `${y}px`;

      const { lensSize, zoomRatio } = readZoomConfig(host);
      const bgW = metrics.width * zoomRatio;
      const bgH = metrics.height * zoomRatio;
      const imgLeft = -(relX * zoomRatio - lensSize / 2);
      const imgTop = -(relY * zoomRatio - lensSize / 2);

      lensImg.style.width = `${bgW}px`;
      lensImg.style.height = `${bgH}px`;
      lensImg.style.left = `${imgLeft}px`;
      lensImg.style.top = `${imgTop}px`;
    };

    const onEnter = (event) => {
      if (!DESKTOP_MQ.matches || !isActiveSlide(host)) return;

      zoomUrl = getZoomImageUrl(image);
      if (!zoomUrl) return;

      removeLens();

      lens = document.createElement('div');
      lens.className = 'renewbox-zoom-lens';
      lens.setAttribute('aria-hidden', 'true');

      const view = document.createElement('div');
      view.className = 'renewbox-zoom-lens__view';

      lensImg = document.createElement('img');
      lensImg.className = 'renewbox-zoom-lens__img';
      lensImg.alt = '';
      lensImg.decoding = 'async';
      lensImg.src = zoomUrl;

      view.appendChild(lensImg);
      lens.appendChild(view);
      mount.appendChild(lens);

      if (event) updateLensImage(event);
    };

    const onMove = (event) => updateLensImage(event);

    const onLeave = () => removeLens();

    host.addEventListener('mouseenter', onEnter);
    host.addEventListener('mousemove', onMove);
    host.addEventListener('mouseleave', onLeave);
  }

  function init(scope) {
    if (!DESKTOP_MQ.matches) return;
    scope.querySelectorAll('.renewbox-image-zoom-host').forEach(bindZoomHost);
  }

  function initMainProductGalleries() {
    document.querySelectorAll('[id^="MainProduct-"] media-gallery').forEach((gallery) => {
      init(gallery);
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (viewer) {
        viewer.addEventListener('slideChanged', () => {
          gallery.querySelectorAll('.renewbox-zoom-lens').forEach((el) => el.remove());
          gallery.querySelectorAll('.renewbox-image-zoom-host').forEach((host) => {
            delete host.dataset.renewboxZoomBound;
          });
          init(gallery);
        });
      }
    });
  }

  function boot() {
    initMainProductGalleries();
    window.addEventListener('load', initMainProductGalleries, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  DESKTOP_MQ.addEventListener('change', () => {
    document.querySelectorAll('.renewbox-zoom-lens').forEach((el) => el.remove());
    document.querySelectorAll('.renewbox-image-zoom-host').forEach((host) => {
      delete host.dataset.renewboxZoomBound;
    });
    initMainProductGalleries();
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector?.('[id^="MainProduct-"]')) {
      initMainProductGalleries();
    }
  });
})();
